import { AxiosError } from 'axios'
import useSWR from 'swr'

import { fetchAttributes } from 'api'
import {
  AttributeOption,
  attributeOptionToFilter,
  FilterConfigAndAvailableValues
} from 'context/filtersContext'

export const useAttributeFilters = (): FilterConfigAndAvailableValues[] | null => {
  const { data } = useSWR<AttributeOption[], AxiosError>(
    `/attrib`,
    async () => {
      const { data } = await fetchAttributes()
      return data
    },
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  )

  if (!data) {
    return []
  }

  const attributeFilters: FilterConfigAndAvailableValues[] = []
  const labels = new Set()

  for (const option of data) {
    if (!labels.has(option.label)) {
      attributeFilters.push(attributeOptionToFilter(option))
    }

    labels.add(option.label)
  }

  return attributeFilters
}
